import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/Search.module.css";
import NavButton from "../../components/ui/navbutton/NavButton";
import LicencePlate from "../../components/ui/licence_plate/LicencePlate";
import SideTicket from "../../components/ui/side_ticket/SideTicket";
import DataContext from "../../context/DataContext";
import { calculateValues } from "../../utils/utils";
import useCurrencySymbol from "../../hooks/useCurrencySymbol";

import { useTranslation } from "react-i18next";
import SideSettlement from "../../components/ui/side_settlement/SideSettlement";
import Button from "../../components/ui/button/Button";
import InputCheck from "../../components/ui/input_check/InputCheck";
import PlatePanel from "./PlatePanel";

/**
 * SidePanel component
 */
const SidePanel = ({
    selectedInstalments,
    selectedSettlements,
    setSelectedInstalments,
    handleCheckInstalment,
    handleCheckSettlement,
    isSelectedSettlements,
    handleSelectAllSettlements,
}) => {
    const { t } = useTranslation();
    const {
        responseData,
        connection,
        homePath,
        ticketType,
        currentTicket,
        selectedTickets,
        setSelectedTickets,
    } = useContext(DataContext);

    const currency = useCurrencySymbol();
    const [clickedTicket, setClickedTicket] = useState("");
    const [isSelectedTickets, setIsSelectedTickets] = useState(false);

    /**
     * Check box ticket handle
     * Add checked ticket to selected tickets
     */
    const handleCheck = (event) => {
        event.stopPropagation(); // Prevents the event from bubbling up the DOM tree,
        // preventing the parent event handler from being notified of the event.
        setSelectedTickets((selectedTickets) =>
            selectedTickets?.filter(
                (ticket) => ticket?.ticketNumber === event.target.name,
            ).length
                ? selectedTickets?.filter(
                      (ticket) => ticket?.ticketNumber !== event.target.name,
                  )
                : [
                      ...selectedTickets,
                      {
                          ticketNumber: event.target.name,
                          amount: event.target.value,
                          ticketDate: event.target.dataset.ticketdate,
                          offences: JSON.parse(event.target.dataset.offences),
                      },
                  ],
        );
    };

    useEffect(() => {
        setIsSelectedTickets(
            responseData?.relatedTickets?.length + 1 ===
                selectedTickets?.length,
        );
    }, [selectedTickets]);

    const handleSelectAllTickets = () => {
        if (!isSelectedTickets) {
            const { total } = calculateValues(
                responseData?.ticket?.paymentBalance,
                responseData?.ticket?.amount,
                responseData?.ticket?.transactionItems,
            );
            setSelectedTickets((selectedTickets) =>
                selectedTickets?.filter(
                    (item) =>
                        item?.ticketNumber === responseData?.ticket?.ticketNo,
                ).length
                    ? [...selectedTickets]
                    : [
                          ...selectedTickets,
                          {
                              ticketNumber: responseData?.ticket?.ticketNo,
                              amount: total,
                              ticketDate: responseData?.ticket?.from_DateTime,
                              offences: responseData?.ticket?.offences,
                          },
                      ],
            );
            responseData?.relatedTickets &&
                responseData?.relatedTickets?.length &&
                responseData?.relatedTickets.map((item) => {
                    const { total } = calculateValues(
                        item?.paymentBalance,
                        item?.amount,
                        item?.transactionItems,
                    );
                    setSelectedTickets((selectedTickets) =>
                        selectedTickets?.filter(
                            (ticket) => ticket?.ticketNumber === item?.ticketNo,
                        ).length
                            ? [...selectedTickets]
                            : [
                                  ...selectedTickets,
                                  {
                                      ticketNumber: item?.ticketNo,
                                      amount: total,
                                      ticketDate: item?.from_DateTime,
                                      offences: item?.offences,
                                  },
                              ],
                    );
                });
        } else {
            setSelectedTickets([]);
        }
    };

    /**
     * Ticket click handle
     * Set the clicked ticket to current ticket
     */
    const handleClickedTicket = (ticketNumber) =>
        setClickedTicket(ticketNumber);

    useEffect(() => {
        if (currentTicket && ticketType === 1) {
            handleClickedTicket(currentTicket?.caseNo);
        } else if (currentTicket) {
            handleClickedTicket(currentTicket?.ticketNo);
        }
    }, []);

    return (
        <aside
            className={`${styles.main_side_container} ${currentTicket?.isPlateScofflawActive ? styles.scoffloaw_side_container : ""}  v-flex-container`}
        >
            {!connection?.isPayment ? (
                <div
                    className={`${styles.side_Plate_container} v-flex-container`}
                >
                    <PlatePanel responseData={responseData} />
                </div>
            ) : (
                <></>
            )}
            <section
                className={`${styles.main_side_tickets_container} v-flex-container`}
            >
                {/* {console.log("responseData:", responseData)}
                {console.log("selectedTickets:", selectedTickets)} */}

                {responseData?.relatedTickets?.length > 1 ||
                (responseData?.ticket &&
                    responseData?.relatedTickets?.length) ? (
                    <div
                        className={`${styles.select_all_button_container} flex-container`}
                    >
                        {/* <InputCheck
                            label={t("select all")}
                            inputId={"selectAll"}
                            inputValue={isSelectedTickets}
                            handleChangeFunction={handleSelectAllTickets}
                            sideMenuCheck={true}
                        /> */}
                        <Button
                            body={
                                !isSelectedTickets
                                    ? t("select all tickets")
                                    : t("deselect all tickets")
                            }
                            size={"small"}
                            onClickFuction={handleSelectAllTickets}
                            fullWidth={true}
                        />
                    </div>
                ) : (
                    <></>
                )}
                {responseData?.ticket ? (
                    <>
                        <h4
                            className={`${styles.ticket_type_label} flex-container`}
                        >
                            {t(`searched ticket`)}:
                        </h4>
                        <SideTicket
                            ticket={responseData?.ticket}
                            searched={true}
                            clickedTicket={clickedTicket}
                            handleClickedTicket={handleClickedTicket}
                            handleCheckFunction={handleCheck}
                            currency={currency}
                        />
                    </>
                ) : (
                    <></>
                )}

                {responseData?.settlements?.length > 1 ? (
                    <div
                        className={`${styles.select_all_button_container} flex-container`}
                    >
                        <Button
                            body={
                                !isSelectedSettlements
                                    ? t("select all settlements")
                                    : t("deselect all settlements")
                            }
                            size={"small"}
                            onClickFuction={handleSelectAllSettlements}
                            fullWidth={true}
                        />
                    </div>
                ) : (
                    <></>
                )}

                {responseData?.settlements?.length ? (
                    <>
                        <h4
                            className={`${styles.ticket_type_label} flex-container`}
                        >
                            {t(`settlements`)}:
                        </h4>
                        {responseData?.settlements?.map((settlement, idx) => (
                            <SideSettlement
                                key={`${idx}-${settlement?.caseid}`}
                                selectedSettlements={selectedSettlements}
                                selectedInstalments={selectedInstalments}
                                setSelectedInstalments={setSelectedInstalments}
                                handleCheckInstalment={handleCheckInstalment}
                                ticket={settlement}
                                searched={false}
                                clickedTicket={clickedTicket}
                                handleCheckSettlement={handleCheckSettlement}
                                handleClickedTicket={handleClickedTicket}
                                currency={currency}
                            />
                        ))}
                    </>
                ) : (
                    <></>
                )}

                {/* show related tickets if available */}
                {responseData?.relatedTickets?.length ? (
                    <>
                        <h4
                            className={`${styles.ticket_type_label} flex-container`}
                        >
                            {t(`related tickets`)}:
                        </h4>
                        {responseData?.relatedTickets?.map((ticket) => (
                            <SideTicket
                                key={ticket?.ticketNo}
                                ticket={ticket}
                                searched={false}
                                clickedTicket={clickedTicket}
                                handleClickedTicket={handleClickedTicket}
                                handleCheckFunction={handleCheck}
                                currency={currency}
                            />
                        ))}
                    </>
                ) : (
                    <></>
                )}
            </section>
        </aside>
    );
};

export default SidePanel;
